/** HEIC/HEIF → JPEG conversion. The heavy wasm decoder is loaded on demand only. */

/**
 * Convert a HEIC/HEIF blob to JPEG. `heic-to` (bundled, no CDN) is imported
 * dynamically so guests who pick regular JPEGs never download the decoder.
 */
export async function heicToJpeg(blob: Blob): Promise<Blob> {
  const { heicTo } = await import("heic-to");
  return heicTo({ blob, type: "image/jpeg", quality: 0.92 });
}
